import { Link } from 'gatsby';
import React from 'react';

export const NavbarItem = ({ title, link, isMobile = false }) => {
  const defaultClasses = isMobile
    ? 'text-gray-800 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium'
    : 'py-2 px-2 text-gray-800 font-semibold border-b-4 border-transparent hover:text-secondary transition duration-300';
  const activeClasses = isMobile
    ? 'bg-secondary block px-3 py-2 rounded-md text-base font-medium'
    : 'py-2 px-2 text-secondary border-b-4 border-secondary font-semibold';

  return (
    <Link
      to={link}
      className={`${defaultClasses} text-lg tracking-tight`}
      activeClassName={activeClasses}
      aria-current="page"
      partiallyActive={link === '/' ? false : true}
    >
      {title}
    </Link>
  );
};
